const SELECT_MAP = {
    temp : {
        name : 'Air Temperature',
        mapKey : 'temp',
        unitHtml : '(<sup>o</sup>C)'
    },
    humidity : {
        name : 'Humidity',
        mapKey : 'humidity',
        unitHtml : '(% RH)'
    },
    bar_pressure :{
        name : 'Barometric Pressure',
        mapKey : 'bar_pressure',
        unitHtml : '(kPa)'
    },
    vapor_pressure : {
        name : 'Vapour Pressure',
        mapKey : 'vapor_pressure',
        unitHtml : '(kPa)'
    },
    solar : {
        name : 'Solar Radiation',
        mapKey : 'solar',
        unitHtml : '(W/m<sup>2</sup>)'
    },
    precipitation : {
        name : 'Precipitation',
        mapKey : 'precipitation',
        unitHtml : '(mm/h)'
    },
    hum_temp : {
        name : 'Humidity Temperature',
        mapKey : 'hum_temp',
        unitHtml : '(<sup>o</sup>C)'
    },
    wind_speed : {
        name : 'Horizontal Wind Speed',
        mapKey : 'wind_speed',
        unitHtml : '(m/s)'
    },
    gust : {
        name : 'Wind Gust',
        mapKey : 'gust',
        unitHtml : '(<sup>o</sup>C)'
    },
    wind_direction : {
        name : 'Wind Direction',
        mapKey : 'wind_direction',
        unitHtml : '(<sup>o</sup>)'
    },
    tilt : {
        name : 'Tilt',
        mapKey : 'tilt',
        unitHtml : '(<sup>o</sup>)'
    },
    strike : {
        name : 'Lightning Strike',
        mapKey : 'strike',
        unitHtml : '(strike)'
    },
    light_avr : {
        name : 'Lightning Average',
        mapKey : 'light_avr',
        unitHtml : '(<sup>o</sup>C)'
    }
}

export default SELECT_MAP;